module.exports = "/images/location.png?cdf493e2c2c2c6f76c7627e3536e9b4e";